var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isLiveMessagesPaused)?_c('div',{staticClass:"mb-4 p-4 bg-light"},[_vm._v(" Live messages are paused. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }